import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const MoveUp: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M8 6L12 2L16 6' }],
    ['path', { d: 'M12 2V22' }],
  ],
];

export default MoveUp;
